.title {
  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    fill: var(--paletteRed0);
    margin-right: 10px;
  }
}

.body {
  display: flex;
  justify-content: center;
  text-align: left;
  flex-direction: column;
}

.roleRelatedOptions {
  display: flex;
  flex-direction: column;
}

.optionLabel {
  display: flex;
  flex-direction: column;
  gap: var(--spacingSm);

  > span {
    color: var(--paletteNeutral3);
  }
}
